/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IComponentProps, ICoreContext } from '@msdyn365-commerce/core';

import React from 'react';
import { IProductReturnRow } from '../order-return-initiated-details-table.component';

export interface IOrderReturnInitiatedDetailsTableRowData {
    rowData: IProductReturnRow
}

/**
 * Interface for  table props.
 */
export interface IOrderReturnInitiatedDetailsTableRowProps extends IComponentProps<IOrderReturnInitiatedDetailsTableRowData> {
    context: ICoreContext;
    className: string;
}

/**
 * Renders  table rows for desktop view.
 * @param props - Configuration for the rows.
 * @returns A react node with a list of  rows for desktop view.
 */
export const OrderReturnInitiatedDetailsDesktopTableRowCellComponent: React.FC<IOrderReturnInitiatedDetailsTableRowProps> = (props: IOrderReturnInitiatedDetailsTableRowProps) => {
    const rowData = props.data.rowData;

    return (
        <>
            <td className={`${props.className}__product-sku`}>
                {rowData.productItemId}
            </td>
            <td className={`${props.className}__product-name`}>
                {rowData.productName}
            </td>
            <td className={`${props.className}__product-quantity`}>
                {rowData.productQuantity}
            </td>
            <td className={`${props.className}__product-request-status`}>
                {rowData.productRequestStatus}
            </td>
        </>
    );
};
/**
 *  Table row component.
 * @param props - Configuration of the component.
 * @returns React node for the row.
 */
export const OrderReturnInitiatedDetailsTableRow: React.FC<IOrderReturnInitiatedDetailsTableRowProps> = (props: IOrderReturnInitiatedDetailsTableRowProps) => {
    const rowClassName = `${props.className}__row`;

    const headerCells = <OrderReturnInitiatedDetailsDesktopTableRowCellComponent {...props} />;

    return (
        <tr className={rowClassName}>{headerCells}</tr>
    );
};
